import { render } from "./SectionIdForm.vue?vue&type=template&id=467b6842"
import script from "./SectionIdForm.vue?vue&type=script&lang=js"
export * from "./SectionIdForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__